import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceProductService } from '@interfaces';

@Pipe({
  name: 'getValueType'
})
export class GetValueType implements PipeTransform {
  public transform(orderProductService: MaintenanceProductService, companyId?: string): string {
    const productServiceCompany = orderProductService.item.productServiceCompanies.find(
      (psc) => psc.company.id === companyId
    );

    return productServiceCompany.valueType.toUpperCase();
  }
}
